









































































import { Component, Prop, Vue } from "vue-property-decorator";
import EmploymentService from "@/services/EmploymentService";
import { EmploymentFilter } from "@/dto/payroll/Filters";
import Workspaces from "@/state/Workspaces";
import { TimeSheetFilter, TimeSheetPayPeriod } from "@/dto/payroll/timesheet/TimesheetPayloads";
import { processError } from "@/utils/ComponentUtils";
import Application from "@/state/Application";
import { EmploymentStatus } from "@/components/payroll/business/employments/contractors/Contractor";
import { namespace } from "vuex-class";
import { CounterpartyType } from "@/constants/CounterpartyType";
import moment from "moment-timezone";
import TimeSheetPeriod from "@/components/payroll/timesheet/TimeSheetPeriod.vue";
import TimesheetService from "@/services/payroll/TimesheetService";
import BTPortalCollapse from "@/components/common/BTPortalCollapse.vue";
import PortalRadio from "@/components/v2/common/PortalRadio.vue";
import SelectOption from "@/components/common/SelectOption";
import TimesheetRequest from "@/components/payroll/timesheet/TimesheetRequest.vue";
import BusinessCalendarTimesheet from "@/components/payroll/timesheet/BusinessCalendarTimesheet.vue";
import { IEmployment } from "@/dto/payroll/IEmployment";
import { ProjectDTO, ProjectDTOWithHolder } from "@/dto/payroll/ProjectDTOs";
import CompanyService from "@/services/CompanyService";

const AppModule = namespace("App");

export interface ExistPolicies {
	pto: boolean,
	slp: boolean
}

@Component(
	{
		computed: {
			SelectOption() {
				return SelectOption
			},
		},
		components: {
			BusinessCalendarTimesheet,
			TimesheetRequest,
			PortalRadio,
			BTPortalCollapse,
			TimeSheetPeriod
		}
	}
)
export default class IndividualTimesheet extends Vue {
	@Prop()
	private timeFormat!: string
	@Prop({default: [], required: false})
	private employmentsOfProject!: IEmployment[]

	private project: number | null = null

	private employments: Array<IEmployment> = [];
	private projects: Array<ProjectDTOWithHolder> = [];

	private selectedProject: ProjectDTOWithHolder | null = null

	private selectedEmployee: IEmployment | null = null

	private timesheetPeriods: Array<TimeSheetPayPeriod> = [];

	private employmentFilter: EmploymentFilter = new EmploymentFilter(
		{
			types: ["STAFF", "FOREIGN"],
			contractorType: CounterpartyType.PERSON,
			detailsId: Workspaces.getCurrent.id,
			status: [EmploymentStatus.ACTIVE, EmploymentStatus.PENDING_FOR_DOCUMENTS, EmploymentStatus.NEW]
		}
	)

	private timesheetFilter = new TimeSheetFilter(
		{
			startDate: moment().set({weekday: 0}).format("YYYY-MM-DD"),
			endDate: moment().set({weekday: 6}).format("YYYY-MM-DD"),
			employmentsId: this.employments.map(it => it.id) as number[],
			projectId: this.project
		}
	)

	public created(): void {
		Application.startLoading()
			.then(this.loadEmployments)
			.then(this.loadAllManagedProjects)
      .then(() => {
        const selectedEmployeeTimesheet = localStorage.selectedEmployeeTimesheet ? JSON.parse(localStorage.selectedEmployeeTimesheet) : null;
        const selectedProjectTimesheet = localStorage.selectedProjectTimesheet ? JSON.parse(localStorage.selectedProjectTimesheet) : null;
        if (selectedEmployeeTimesheet && selectedProjectTimesheet) {
          this.selectProjectWithEmployee(selectedProjectTimesheet, selectedEmployeeTimesheet);
        } else if (selectedEmployeeTimesheet && selectedProjectTimesheet === null) {
          this.selectAllProjects(selectedEmployeeTimesheet.employer.name);
        }
      })
			.finally(Application.stopLoading)
	}

	private loadEmployments() {
		return EmploymentService.getAllByFilter(this.employmentFilter).then(
			res => {
				this.employments = res.data;
					this.projects = this.employments.flatMap(employment => employment.projects.map(it => new ProjectDTOWithHolder(employment, it)))
			},
			err => processError(err, this)
		)
	}

	get projectsByCompanyName(): Array<{ companyName: string, projects: ProjectDTOWithHolder[] }> {
		const grouped = new Map<string, ProjectDTOWithHolder[]>();

		this.employments.forEach((employment: IEmployment) => {
			grouped.set(employment.employer.name, [])
		});

		this.projects.filter(it => !it.manager || (it.employments.length > 0 && it.manager)).forEach((project: ProjectDTOWithHolder) => {
			const companyName = project.company.name;
			if (!grouped.has(companyName)) {
				grouped.set(companyName, []);
			}
			grouped.get(companyName)?.push(project);
		});

		return Array.from(grouped.entries()).map(([companyName, projects]) => ({
			companyName,
			projects
		}));
	}

	groupProjectsByCompanyId(arr: ProjectDTOWithHolder[]): Array<{ companyId: number, projects: ProjectDTOWithHolder[] }> {
		const grouped = new Map<number, ProjectDTOWithHolder[]>();

		arr.forEach((project: ProjectDTOWithHolder) => {
			const companyId = project.company.id;
			if (!grouped.has(companyId)) {
				grouped.set(companyId, []);
			}
			grouped.get(companyId)?.push(project);
		});

		return Array.from(grouped.entries()).map(([companyId, projects]) => ({
			companyId,
			projects
		}));
	}

	private loadAllManagedProjects(): Promise<void> {
		const managedProjects = this.projects.filter(it => it.manager);
		if (managedProjects.length == 0) return Promise.resolve()
		return Promise.all(
			this.groupProjectsByCompanyId(managedProjects)
				.filter(pair => pair.projects.length > 0)
				.map(pair => this.loadManagedProjects(pair.companyId, pair.projects))
		).then(() => Promise.resolve())
	}

	private loadManagedProjects(companyId: number, projects: ProjectDTO[]) {
		return CompanyService.getProjectsByCompanyId(companyId, projects.map(it => it.id)).then(
			res => res.data.forEach((project: ProjectDTO) => projects.find(it => it.id === project.id)!.employments = project.employments),
			err => processError(err, this)
		)
	}

	private async loadTimesheetRecords() {
		Application.startLoading()
		this.timesheetFilter.startDate = moment().set({weekday: 0}).format("YYYY-MM-DD");
		this.timesheetFilter.endDate = moment().set({weekday: 6}).format("YYYY-MM-DD")
		TimesheetService.getPayPeriod(this.timesheetFilter).then(
			res => {
				this.timesheetPeriods = res.data;
			},
			err => processError(err, this)
		).finally(Application.stopLoading)
	}

	private selectProject(project: ProjectDTOWithHolder) {
		this.timesheetFilter.employmentsId = [project.holder.id!]
		this.timesheetFilter.employerId = project.holder.employer.id
		this.timesheetFilter.projectId = project.id
		this.project = project.id;
		this.selectedProject = project
		this.selectedEmployee = project.holder
    localStorage.selectedEmployeeTimesheet = JSON.stringify(project.holder);
    localStorage.selectedProjectTimesheet = JSON.stringify(project);
		this.loadTimesheetRecords()
	}

	private selectProjectWithEmployee(project: ProjectDTOWithHolder, employee: IEmployment) {
		this.timesheetFilter.employmentsId = [employee.id!]
		this.timesheetFilter.employerId = employee.employer.id
		this.timesheetFilter.projectId = project.id
		this.project = project.id;
		this.selectedProject = project
		this.selectedEmployee = project.holder
    localStorage.selectedEmployeeTimesheet = JSON.stringify(employee);
    localStorage.selectedProjectTimesheet = JSON.stringify(project);
		this.loadTimesheetRecords()
	}

	private selectAllProjects(companyName: string) {
		const employee = this.employments.find(it => it.employer.name === companyName)!
		this.timesheetFilter.employmentsId = [employee.id!]
		this.timesheetFilter.employerId = employee.employer.id
		this.timesheetFilter.projectId = null
		this.selectedEmployee = employee
		this.selectedProject = null
		this.project = null;
    localStorage.selectedEmployeeTimesheet = JSON.stringify(employee);
    localStorage.selectedProjectTimesheet = JSON.stringify(null);
		this.loadTimesheetRecords()
	}

  get dropdownText(): string {
    return this.selectedEmployee ? `${this.selectedEmployee.employer.name} ${this.selectedProject ? `– ${this.selectedProject.title}` : ''}` : 'Select project';
  }
}

